import React from 'react';
import { ArrowUpCircle } from 'lucide-react';
import { BannerContainer } from '../BannerContainer';
import { BannerContent } from '../BannerContent';
import { BannerActions } from '../BannerActions';
import { UsageProgressCard } from '../UsageProgressCard';
import { FeaturesGrid } from '../FeaturesGrid';
import { BANNER_THEMES, FEATURE_SETS, ACTION_CONFIGS } from '../config/bannerConfig';
import { UsageDetails } from '../../../types/subscription';
import { getUsageDescription } from '../utils/bannerUtils';

interface LimitWarningBannerProps {
  usage?: UsageDetails;
  planName?: string;
  onDismiss?: () => void;
  className?: string;
}

export const LimitWarningBanner: React.FC<LimitWarningBannerProps> = ({
  usage,
  planName,
  onDismiss,
  className
}) => {
  const theme = BANNER_THEMES.limit_warning;
  const features = FEATURE_SETS.warning;
  const actions = ACTION_CONFIGS.warning;

  // Generate dynamic description based on usage
  const dynamicDescription = usage 
    ? getUsageDescription(usage, planName)
    : theme.description;

  return (
    <BannerContainer
      variant="gradient"
      theme={theme.theme}
      onDismiss={onDismiss}
      className={className}
    >
      <BannerContent
        layout="centered"
        emoji={theme.emoji}
        emojiAnimation={theme.emojiAnimation}
        title={theme.title}
        description={dynamicDescription}
        titleColor={theme.titleColor}
        descriptionColor={theme.descriptionColor}
      >
        {/* Usage Progress */}
        {usage && (
          <UsageProgressCard
            usage={usage}
            variant="detailed"
            theme="orange"
          />
        )}

        {/* Action buttons */}
        <BannerActions
          primary={{
            ...actions.primary,
            icon: <ArrowUpCircle className="h-5 w-5 mr-2" />,
            onClick: onDismiss
          }}
          secondary={{
            ...actions.secondary,
            onClick: onDismiss
          }}
        />

        {/* Plan benefits preview */}
        <FeaturesGrid 
          features={features}
          variant="light"
          borderColor="border-orange-200"
          textColor="text-orange-700"
        />
      </BannerContent>
    </BannerContainer>
  );
};